import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserAuthentication} from '../../../service/restAngular/user-authentication';

@Component({
  selector: 'app-account-activation',
  templateUrl: './account-activation.component.html',
  providers: [UserAuthentication],
  styleUrls: ['./account-activation.component.css']
})
export class AccountActivationComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private userAuthentication: UserAuthentication,
              private router: Router) { }

  ngOnInit() {
     this.route.params.subscribe(params => {
       this.userAuthentication.activateAccount(params.token).subscribe((response) => {
         this.router.navigateByUrl('/');
       });
    });
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/login-signup/account-activation/account-activation.component.ts